import { render, staticRenderFns } from "./front-distributionproduct-list.vue?vue&type=template&id=462e349c&"
import script from "./front-distributionproduct-list.vue?vue&type=script&lang=ts&"
export * from "./front-distributionproduct-list.vue?vue&type=script&lang=ts&"
import style0 from "./front-distributionproduct-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports